import { DirectionalHint } from "@fluentui/react";
import React, { FunctionComponent } from "react";
import { CoachmarkInfo } from "../CoachmarkInfo";
import { PFCoachmark } from "../PFCoachmark";
import { useTranslation } from "../../Locales/i18n/localizationService";
import { CoachmarkLocaleItem } from "../../Locales/Coachmarks/Locale_CoachmarkItem";



export const RootSettingsEditorCoachmarks: FunctionComponent<any> = React.memo(props => {
	const { t } = useTranslation();
	const navGroupingText = new CoachmarkLocaleItem(t("Coachmarks.AdminDashboard.NavGroupings.Headline"), t("Coachmarks.AdminDashboard.NavGroupings.Text"));
	const _navGroupings  = new CoachmarkInfo("rootsettings-groupings", ".tp-object-editor-nav-menu", navGroupingText, DirectionalHint.rightCenter);

	return	<>
				<PFCoachmark CoachmarkInfo={_navGroupings} />
			</>
})